import { render, staticRenderFns } from "./myXkgc.vue?vue&type=template&id=47d6e01e&scoped=true&"
import script from "./myXkgc.vue?vue&type=script&lang=js&"
export * from "./myXkgc.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/reportEditor/reportEditor.less?vue&type=style&index=0&id=47d6e01e&lang=less&scoped=true&"
import style1 from "./myXkgc.vue?vue&type=style&index=1&id=47d6e01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6e01e",
  null
  
)

component.options.__file = "myXkgc.vue"
export default component.exports